import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/Collapsible.css';
import { onActionKey } from '../utils';

Collapsible.propTypes = {
    header: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    initiallyCollapsed: PropTypes.bool,
    error: PropTypes.string,
};

function Collapsible(props) {
    const {
        header,
        children,
        className = null,
        initiallyCollapsed = false,
        error = null,
    } = props;
    const { t } = useTranslation();
    const [isExpanded, setExpanded] = useState(!initiallyCollapsed);
    const toggle = () => setExpanded(!isExpanded);
    return (
        <div className={className}>
            <div className="collapsible--header" onClick={toggle} onKeyUp={onActionKey(toggle)} role="button" tabIndex={0}>
                <div className="collapsible--header--handler">
                    {header}
                    {
                        isExpanded
                            ? <FontAwesomeIcon icon="caret-down" title={t('misc.collapse')} />
                            : <FontAwesomeIcon icon="caret-right" title={t('misc.expand')} />
                    }
                </div>
                {!isExpanded && error && (
                    <div className="validation-error">{error}</div>
                )}
            </div>
            {isExpanded && children}
        </div>
    );
}

export default Collapsible;
